'use client';

import { c as _c } from "react/compiler-runtime";
type LogoOverlayThumbnailStackProps = {
  /** URL of the foreground thumbnail. Shows a placeholder when undefined. */
  thumbnailUrl?: string;
  alt?: string;
  /** 'square' = 24×24px (games), 'landscape' = 32×18px (experiences). */
  thumbnailShape: 'square' | 'landscape';
};

/**
 * Renders two horizontal bars (hamburger-style) above a thumbnail strip.
 * Top bar is shorter (#AABDD6), bottom bar is longer (#D5E2F2).
 */
export default function LogoOverlayThumbnailStack(t0) {
  const $ = _c(7);
  const {
    thumbnailUrl,
    alt: t1,
    thumbnailShape
  } = t0;
  const alt = t1 === undefined ? "" : t1;
  const imgClass = thumbnailShape === "square" ? "h-[24px] w-[24px] rounded-sm border-[1.2px] border-[rgba(213,226,242,1)] object-cover" : "h-[18px] w-8 rounded-sm rounded-sm border-[1.2px] border-[rgba(213,226,242,1)] object-cover";
  const placeholderClass = thumbnailShape === "square" ? "h-[24px] w-[24px] rounded-sm border-[1.2px] border-[rgba(213,226,242,1)] bg-white" : "h-[18px] w-8 rounded-sm border-[1.2px] border-[rgba(213,226,242,1)] bg-white";
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-0 w-3 border-b-2 border-[#AABDD6]" />;
    t3 = <div className="h-0 w-[19px] border-b-2 border-[#D5E2F2]" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== alt || $[3] !== imgClass || $[4] !== placeholderClass || $[5] !== thumbnailUrl) {
    t4 = <div className="flex h-[27px] w-8 shrink-0 flex-col items-center justify-center gap-0.5">{t2}{t3}{thumbnailUrl ? <img src={thumbnailUrl} alt={alt} className={imgClass} /> : <div className={placeholderClass} />}</div>;
    $[2] = alt;
    $[3] = imgClass;
    $[4] = placeholderClass;
    $[5] = thumbnailUrl;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}